import React, { useState } from "react";
import { Chart } from "primereact/chart";
import ChartDivider from "../../ChartDivider";
import { Button } from "primereact/button";
import ChartSkeleton from "../../../Skeletons/ChartSkeleton";
import { timeOfDayChartOptions } from "../../../../utils/chartOptions/dashboard/amount";

const TimeOfDay = React.memo(function TimeOfDay(props) {
  const options = timeOfDayChartOptions(props?.activeTag);
  const ToggleButtons = () => {
    const [activeButton, setActiveButton] = useState("# OF OUNCES");

    const handleClick = (label) => {
      setActiveButton(label);
    };

    return (
      <div
        className="d-flex align-items-center gap-2"
        style={{ float: "right" }}
      >
        {/* <Button
          label="% OF TOTAL"
          className={`px-3 py-2 fw-bold fs-6 ${
            activeButton === "% OF TOTAL"
              ? "btn-primary text-white"
              : "btn-light text-dark"
          }`}
          onClick={() => handleClick("% OF TOTAL")}
          style={{
            borderRadius: "10px",
            border: "none",
            height: "25px",
            backgroundColor:
              activeButton === "% OF TOTAL" ? "#002D42" : "#E0E0E0",
          }}
          disabled
        /> */}
        <Button
          label={props?.activeTag === "OZ" ? `# of Ounces` : `# of Grams`}
          className={`px-3 py-2 fw-bold fs-6 btn-primary text-white`}
          style={{
            borderRadius: "10px",
            border: "none",
            height: "25px",
            backgroundColor: "#002D42",
          }}
        />
      </div>
    );
  };

  return (
    <>
      <div className="mt-4" style={{ maxWidth: "100%" }}>
        <div className="mb-4">
          <h5 className="fw-bold mb-1 text-start">
            <span>Time of Day</span>
            <ToggleButtons />
          </h5>
          <p
            className="mb-0 text-start fw-bold fs-12 py-3"
            style={{ color: "#6c757d" }}
          >
            Average {props?.activeTag === "OZ" ? "ounces" : "grams"} used per
            occasion by time of day
          </p>
          <div className="col-12">
            {!props?.loading ? (
              <Chart
                type="bar"
                data={props?.chartData}
                options={options}
                redraw={(props?.isFilterHide || props?.showSidebar).toString()}
              />
            ) : (
              <ChartSkeleton />
            )}
          </div>
          <ChartDivider />
        </div>
      </div>
    </>
  );
});

export default TimeOfDay;
